import getCountryAcceptance from "/";
const { useQuery } = require("react-query");

function useCountryAcceptance() {
  return useQuery(
    "country_acceptance",
    async () => {
      const response = await getCountryAcceptance();
      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(response.status);
      }
    },
    { refetchOnWindowFocus: false } // this data doesnt update often
  );
}

export default useCountryAcceptance;
